import { useRef, useEffect, useState } from 'react'

import NavBar from './components/NavBar'
import GraphicDesign from './components/GraphicDesign'
import Title from './components/Title'
import Contact from './components/Contact'
import WebProjects from './components/WebProjects'

export default function App() {
	const scrollElements = {
		home: useRef(null),
		graphicDesign: useRef(null),
		web: useRef(null),
		contact: useRef(null),
	}

	const [isDark, setIsDark] = useState(false)

	const executeScroll = ref =>
		ref.current.scrollIntoView({ behavior: 'smooth' })

	useEffect(() => {
		if (isDark) {
			document.body.classList.replace('light', 'dark')
		} else {
			document.body.classList.replace('dark', 'light')
		}
	}, [isDark])

	useEffect(() => {
		const storedTheme = localStorage.getItem('theme')
		if (storedTheme === 'dark') {
			setIsDark(true)
		} else {
			setIsDark(false)
		}
	}, [])

	return (
		<>
			<NavBar
				scrollElements={scrollElements}
				executeScroll={executeScroll}
				isDark={isDark}
				setIsDark={setIsDark}
			/>
			<main className='scroller'>
				<Title scrollElements={scrollElements} executeScroll={executeScroll} />
				<GraphicDesign sectionRef={scrollElements.graphicDesign} />
				<WebProjects sectionRef={scrollElements.web} isDark={isDark} />
				<Contact sectionRef={scrollElements.contact} />
			</main>
		</>
	)
}
